(() => {
  if (window.__pbHeroAutoplayGuardInstalled) return;
  window.__pbHeroAutoplayGuardInstalled = true;

  const selector = 'slideshow-component[data-pb-home-hero]';
  const heroesWithin = (scope) => scope.matches?.(selector) ? [scope] : Array.from(scope.querySelectorAll(selector));

  function initialise(scope) {
    heroesWithin(scope).forEach((hero) => {
      const button = hero.querySelector('.slideshow__autoplay');
      if (!hero.isConnected || hero._pbAutoplayCleanup || !button || hero.slider?.getAttribute('data-autoplay') !== 'true') return;

      const nativePlay = hero.play.bind(hero);
      const nativePause = hero.pause.bind(hero);
      const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      const hover = window.matchMedia('(hover: hover)');
      let visible = !('IntersectionObserver' in window);
      let disposed = false;

      hero.play = function () {
        const readingFocus = hero.contains(document.activeElement) && !button.contains(document.activeElement);
        const readingHover = hover.matches && hero.matches(':hover') && !button.matches(':hover');
        if (!hero.isConnected || hero.slider.getAttribute('data-autoplay') !== 'true' || document.hidden || !visible || readingFocus || readingHover || button.classList.contains('slideshow__autoplay--paused')) {
          nativePause();
          return;
        }
        nativePlay();
      };

      const sync = () => { if (!disposed) hero.play(); };
      const afterFocus = () => queueMicrotask(sync);
      const respectMotion = () => {
        if (motion.matches) {
          hero.autoplayButtonIsSetToPlay = false;
          hero.togglePlayButtonState(true);
        }
        sync();
      };
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
        const entry = entries.find((item) => item.target === hero);
        if (!entry) return;
        visible = entry.isIntersecting && entry.intersectionRatio >= 0.15;
        sync();
      }, { threshold: 0.15 }) : null;

      hero.addEventListener('mouseenter', sync);
      hero.addEventListener('mouseleave', sync);
      hero.addEventListener('focusin', sync);
      hero.addEventListener('focusout', afterFocus);
      button.addEventListener('click', afterFocus);
      document.addEventListener('visibilitychange', sync);
      motion.addEventListener('change', respectMotion);
      observer?.observe(hero);
      respectMotion();

      hero._pbAutoplayCleanup = () => {
        disposed = true;
        nativePause();
        observer?.disconnect();
        document.removeEventListener('visibilitychange', sync);
        motion.removeEventListener('change', respectMotion);
        hero.removeEventListener('mouseenter', sync);
        hero.removeEventListener('mouseleave', sync);
        hero.removeEventListener('focusin', sync);
        hero.removeEventListener('focusout', afterFocus);
        button.removeEventListener('click', afterFocus);
        hero.play = nativePlay;
        delete hero._pbAutoplayCleanup;
      };
    });
  }

  const whenReady = (scope) => customElements.whenDefined('slideshow-component').then(() => initialise(scope));
  whenReady(document);
  document.addEventListener('shopify:section:load', (event) => whenReady(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    heroesWithin(event.target).forEach((hero) => hero._pbAutoplayCleanup?.());
  });
})();
